export default __webpack_public_path__ + "static/media/tax.815fec3a.png";